import { Link } from "react-router-dom";
import SvgAnimation from "../../../hooks/SvgAnimation";
import BtnArrow from "../../../svg/BtnArrow";
const About = () => {
  const svgIconRef = SvgAnimation('/assets/img/objects/title_shape.svg');

   return (
      <>
      
  
     
       <section className="about-area tg-motion-effects section-py-120">
            <div className="container">
               <div className="row align-items-center justify-content-center">
                  <div className="col-lg-6 col-md-9">
                     <div className="about__images">
                <div style={{ maxWidth: '500px', marginLeft: '-50px' }}>
                  <img 
                    src="/assets/img/coach_banner.png" 
                    alt="img"
                    style={{ width: '100%', height: 'auto' }} 
                  />
                </div>


                        <img src="/assets/img/others/about_shape.svg" alt="img" className="shape alltuchtopdown" />
                        {/* <a onClick={() => setIsVideoOpen(true)} style={{ cursor: "pointer" }} className="popup-video">
                           <svg xmlns="http://www.w3.org/2000/svg" width="22" height="28" viewBox="0 0 22 28" fill="none">
                              <path d="M0.19043 26.3132V1.69421C0.190288 1.40603 0.245303 1.12259 0.350273 0.870694C0.455242 0.6188 0.606687 0.406797 0.79027 0.254768C0.973854 0.10274 1.1835 0.0157243 1.39936 0.00193865C1.61521 -0.011847 1.83014 0.0480663 2.02378 0.176003L20.4856 12.3292C20.6973 12.4694 20.8754 12.6856 20.9999 12.9535C21.1245 13.2214 21.1904 13.5304 21.1904 13.8456C21.1904 14.1608 21.1245 14.4697 20.9999 14.7376C20.8754 15.0055 20.6973 15.2217 20.4856 15.3619L2.02378 27.824C1.83056 27.9517 1.61615 28.0116 1.40076 27.9981C1.18536 27.9847 0.97607 27.8983 0.792638 27.7472C0.609205 27.596 0.457661 27.385 0.352299 27.1342C0.246938 26.8833 0.191236 26.6008 0.19043 26.3132Z" fill="currentcolor" />
                           </svg>
                        </a> */}
                        {/* <div className="about__enrolled" data-aos="fade-right" data-aos-delay="200">
                           <p className="title"><span>36K+</span> Enrolled Students</p>
                           <img src="/assets/img/others/student_grp.png" alt="img" />
                        </div> */}
                     </div>
                  </div>

                  <div className="col-lg-6">
                     <div className="about__content">
                        <div className="section__title">
                           <span className="sub-title">Our Mission</span>
                           <h2 className="title">
                           transform aspiring engineers into 
                              <span className="position-relative title-shape-wrap">
                                 <svg x="0px" y="0px" preserveAspectRatio="none" viewBox="0 0 209 59" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4.74438 7.70565C69.7006 -1.18799 136.097 -2.38304 203.934 4.1205C207.178 4.48495 209.422 7.14626 208.933 10.0534C206.793 23.6481 205.415 36.5704 204.801 48.8204C204.756 51.3291 202.246 53.5582 199.213 53.7955C136.093 59.7623 74.1922 60.5985 13.5091 56.3043C10.5653 56.0924 7.84371 53.7277 7.42158 51.0325C5.20725 38.2627 2.76333 25.6511 0.0898448 13.1978C-0.465589 10.5873 1.61173 8.1379 4.73327 7.70565" fill="currentcolor" />
                                 </svg>
                                 confident 
                              </span>
                              job-ready IT professionals
                           </h2>
                        </div>
                        <p className="desc">We aim to bridge the gap between academic knowledge and industry expectations by offering practice-oriented coaching, hands-on project experience, and personalized mentorship. Whether you're a student, a fresher, or a working professional looking to upskill, our mission is to empower your journey with relevant skills and the confidence to succeed.</p>
                        <ul className="about__info-list list-wrap">
                        <li className="about__info-list-item">
                              <i className="flaticon-angle-right"></i>
                              <p className="content"><strong>Concept:&nbsp;</strong>
                              Learn through real-world scenarios.
                               </p>
                              </li>
                           <li className="about__info-list-item">
                              <i className="flaticon-angle-right"></i>
                              <p className="content"><strong>Practice:&nbsp;</strong> Apply skills through structured exercises. </p>
                           </li>
                           <li className="about__info-list-item">
                              <i className="flaticon-angle-right"></i>
                              <p className="content"><strong>Projects:&nbsp;</strong> Build applications to gain hands-on experienc:</p>
                           </li>
                        </ul>
                        <div className="tg-button-wrap">
                           <Link to="/about-us" className="btn arrow-btn">Enroll Today<BtnArrow /></Link>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </section>
     
     

       
          <section
       className="banner-area banner-bg tg-motion-effects"
       style={{ backgroundImage: `url(/assets/img/banner/banner_bg.png)` }}
     >
      
       <div className="container">
         <div className="row justify-content-between align-items-start">
                   <div className="col-lg-6">
             <div className="banner__images">
               <div style={{ maxWidth: '450px', marginLeft: '45px',paddingTop: '60px' }}>
                 <img
                   src="/assets/img/ph.jpg"
                   alt="img"
                   style={{ width: '75%', height: '450px' }} />
               </div>


             </div>
           </div>
           <div className="col-xl-6 col-lg-6">
                   <div className="section__title">
                           <span className=" sub-title">About</span>
                        </div>
             <div className="banner__content">
               <h3 className="title tg-svg" data-aos="fade-right" data-aos-delay="400" ref={svgIconRef}>
                Our coaching is led by <br /> 
                 <span className="position-relative" style={{ marginLeft: "10px", display: "inline-block" }}>
                   <span className="svg-icon"></span>
                   <svg
                     x="0px"
                     y="0px"
                     width="260px" // Increased width
                     height="65px" // Increased height
                     preserveAspectRatio="none"
                     viewBox="0 0 260 65" // Adjusted viewBox for proper scaling
                     fill="none"
                     xmlns="http://www.w3.org/2000/svg"
                     style={{
                       position: "absolute",
                       left: "10",
                       top: "50%",
                       transform: "translateY(-50%)",
                       zIndex: "-1"
                     }}
                   >
                     <path
                       d="M4 7C80 -1 170 -2 250 4C255 4.5 260 7 260 10C257 25 255 40 253 55C253 58 250 60 245 60C180 65 90 67 10 60C7 59 4 57 3 53C1 40 -1 25 -3 10C-4 5 2 5 4 7"
                       fill="orange" />
                   </svg>
                   <span style={{ position: "relative", zIndex: "1" }}>Raghavendra Kedlaya</span>
                 </span>
                 <br />
                <b> Senior IT Consultant with over 30 years of experience,</b>
               </h3>

               <p data-aos="fade-right" data-aos-delay="600">
                 currently supporting national health programs with 
                    <strong> WHO India,</strong>
                 
                 With decades in enterprise software development, full-stack architectures, and large-scale public health solutions,
    he brings deep industry insight into every session.
         <br />
       Join hands-on training with an industry expert — gain practical experience, build real projects,
          and accelerate your career with confidence.
               </p>
        
               <div className="banner__btn-wrap" data-aos="fade-right" data-aos-delay="800">
                 <Link to="/courses" className="btn arrow-btn">
                   Start Your Journey Today <BtnArrow />
                 </Link>
               </div>
             </div>
           </div>

  
         </div>
       </div>
       <img src="/assets/img/banner/banner_shape01.svg" alt="shape" className="line-shape" data-aos="fade-right" data-aos-delay="1600" />
    
    
  
     </section>
       
       
       </>
      
   );
};

export default About;
